import request from './request.js';
import {requestbody} from './request.js'

//查询业务类型
export async function sjclzx_ywlxquery(params = {}) {
    return await requestbody('business/queryType', 'post', params);
}

export async function sjclzx_ywlxquery_set(params = {}) {
    return await requestbody('business/querySetType', 'post', params);
}

// 查询当前用户下所有的公司信息
export async function queryCompanyList(params = {}) {
    return await request('/sys/queryCompanyList', 'post', params)
}

// 凭证维度分页查询
export async function sjclzx_pz_query(params = {}) {
    return await requestbody('/iinvDataDisposeCenter/voucher/page', 'post', params)
}

// 凭证维度设置业务类型
export async function sjclzx_pz_updateBusinessType(params = {}) {
    return await requestbody('iinvDataDisposeCenter/voucher/updateBusinessType', 'post', params);
}

// 凭证维度设置处理状态
export async function sjclzx_pz_setBusinessMatchStatus(params = {}) {
    return await requestbody('iinvDataDisposeCenter/voucher/setBusinessMatchStatus', 'post', params);
}

// 凭证维度取消关联
export async function sjclzx_pz_disassociate(params = {}) {
    return await requestbody('iinvDataDisposeCenter/voucher/disassociate', 'post', params);
}

// 发票维度分页查询
export async function sjclzx_fp_query(params = {}) {
    return await requestbody('/iinvDataDisposeCenter/invoice/page', 'post', params)
}

// 发票维度设置业务类型
export async function sjclzx_fp_updateBusinessType(params = {}) {
    return await requestbody('iinvDataDisposeCenter/invoice/updateBusinessType', 'post', params);
}

// 发票维度设置处理状态
export async function sjclzx_fp_setBusinessMatchStatus(params = {}) {
    return await requestbody('iinvDataDisposeCenter/invoice/setBusinessMatchStatus', 'post', params);
}

// 发票维度取消关联
export async function sjclzx_fp_disassociate(params = {}) {
    return await requestbody('iinvDataDisposeCenter/invoice/disassociate', 'post', params);
}

// 手工处理凭证数据查询
export async function sjclzx_sgcl_pz_query(params = {}) {
    return await requestbody('iinvDataDisposeCenter/manualProcessing/voucher/matchNodesPage', 'post', params);
}

// 手工处理发票数据查询
export async function sjclzx_sgcl_fp_query(params = {}) {
    return await requestbody('iinvDataDisposeCenter/manualProcessing/invoice/matchNodesPage', 'post', params);
}

// 手工处理 保存手工处理结果
export async function sjclzx_sgcl_saveProcessResults(params = {}) {
    return await requestbody('iinvDataDisposeCenter/manualProcessing/saveProcessResults', 'post', params);
}